/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Medium_ButtonInputs */

const en_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const fr_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyen`)
};

const de_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const it_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const ru_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Середина`)
};

const es_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const zh_cn2_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中等的`)
};

const ja_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中くらい`)
};

const hi_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यम`)
};

const pt_pt2_scene_change_detection_medium_button = /** @type {(inputs: Scene_Change_Detection_Medium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Scene_Change_Detection_Medium_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_medium_button = /** @type {((inputs?: Scene_Change_Detection_Medium_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Medium_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_medium_button(inputs)
	if (locale === "de") return de_scene_change_detection_medium_button(inputs)
	if (locale === "it") return it_scene_change_detection_medium_button(inputs)
	if (locale === "ru") return ru_scene_change_detection_medium_button(inputs)
	if (locale === "es") return es_scene_change_detection_medium_button(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_medium_button(inputs)
	if (locale === "ja") return ja_scene_change_detection_medium_button(inputs)
	if (locale === "hi") return hi_scene_change_detection_medium_button(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_medium_button(inputs)
	return en_scene_change_detection_medium_button(inputs)
});